import React, { Component } from 'react'
import APISection from './../home/APISection';
import BoxButton from './../../../shared/components/BoxButton';
import SideDrawer from "./../contactUs/SideDrawer";
import {
    Box,
    TextField,
} from '@material-ui/core';
import AboutSection from "./../home/AboutSection";
import AboutSection2 from "./../home/AboutSection2";

export default class ApiPage extends Component {

    state = {
        sideDrawerOpen: false
    }

    componentDidMount() {
        const { selectApiPage = () => { } } = this.props;
        selectApiPage();
    }

    openDrawer = () => {
        this.setState({ sideDrawerOpen: true });
    };

    closeDrawer = () => {
        this.setState({ sideDrawerOpen: false });
    };

    render() {
        const { openEmailDialog, pushMessageToSnackbar } = this.props;
        const { sideDrawerOpen } = this.state;
        return (
            <Box position="relative">
                <APISection showScrollDownIndicator={'#about-api'} openEmailDialog={openEmailDialog} pushMessageToSnackbar={pushMessageToSnackbar} history={this.props.history} openRegisterDialog={this.props.openRegisterDialog} />

                <AboutSection
                    id="about-api"
                    bigImage="604c08057f310f7e3f350248"
                    smallTitle="604c08947f310f7e3f350249"
                    bigTitle="604c08ca7f310f7e3f35024a"
                    description="604c08fa7f310f7e3f35024b"
                    smallImage="604c09167f310f7e3f35024c"
                    noHeightStretch
                />
                <AboutSection2
                    bigImage="604c09447f310f7e3f35024d"
                    bigImage2="604c096c7f310f7e3f35024e"
                    bigImage3="604c09d37f310f7e3f35024f"
                    smallTitle="604c09f77f310f7e3f350250"
                    bigTitle="604c0a217f310f7e3f350251"
                    description="604c0a507f310f7e3f350252"
                    noHeightStretch
                />

                <Box position="absolute" right={0} bottom={0}>
                    <BoxButton
                        text="SEND A MESSAGE"
                        iconPath="/images/Screenshot 2020-11-07 at 10.43.49.jpg"
                        onClick={this.openDrawer}
                    />
                </Box>

                <SideDrawer
                    title={<React.Fragment><i>Contact</i> <span>Us</span> <i>About</i> <span>Our</span> <i>API</i></React.Fragment>}
                    open={sideDrawerOpen}
                    onClose={this.closeDrawer}
                    >
                    <Box mt={3}>
                        <TextField label="Name" fullWidth />
                    </Box>
                    <Box mt={3}>
                        <TextField label="Email" fullWidth />
                    </Box>
                    <Box mt={3}>
                        <TextField label="Phone" fullWidth />
                    </Box>
                    <Box mt={3}>
                        <TextField label="Company Name" fullWidth />
                    </Box>
                    <Box mt={3}>
                        <TextField label="Start typing your message..." fullWidth multiline rows={10} />
                    </Box>

                    <BoxButton
                        style={{ position: 'absolute', bottom: 0, left: 0 }}
                        onClick={this.closeDrawer}
                        text={'SEND A MESSAGE'}
                        iconPath="/images/Screenshot 2020-11-07 at 10.43.49.jpg"
                    />
                </SideDrawer>
            </Box>
        )
    }
}
